import { cartActionTypes } from '@Actions/cartActions';

const CartReducers = (state = { }, action) => {
  switch (action.type) {
  case cartActionTypes.GET_CART.LOADING: {
    const { getCartLoading } = action;
    return {
      ...state,
      getCartLoading,
    };
  }
  case cartActionTypes.GET_CART.SUCCESS: {
    const { cart } = action;
    return {
      ...state,
      cart,
    };
  }
  case cartActionTypes.ADD_TO_CART.LOADING: {
    const { addToCartLoading } = action;
    return {
      ...state,
      addToCartLoading,
    };
  }
  case cartActionTypes.GET_SKU_AVAILABILITY.LOADING: {
    const { getSKUAvailabilityLoading } = action;
    return {
      ...state,
      getSKUAvailabilityLoading,
    };
  }
  case cartActionTypes.GET_SKU_AVAILABILITY.SUCCESS: {
    const { skuAvailability } = action;
    return {
      ...state,
      skuAvailability,
    };
  }
  default: {
    return state;
  }
  }
};

export default CartReducers;
